import type { IconProps } from './types';

export const Star06Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M15.5001 3L13.6226 7.12304L9.5 9.00018L13.6226 10.877L15.5001 15L17.3773 10.877L21.5 9.00018L17.3773 7.12304L15.5001 3Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M4.50004 3L4.03066 4.03076L3 4.50005L4.03066 4.96924L4.50004 6L4.96933 4.96924L6 4.50005L4.96933 4.03076L4.50004 3Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M6.5001 13.5L5 16L2.5 17.5001L5 19L6.5001 21.5L8 19L10.5 17.5001L8 16L6.5001 13.5Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
